module.exports = __webpack_public_path__ + "static/media/document.ff2297f7.svg";